import React from "react";
import { Box } from '@mantine/core';

const LoaderLine = ({ statePosition, stateIsTop = true }) => {

    const styleTopBottom = stateIsTop ? { top: 0 } : { bottom: 0 };

    return (
        <div
            style={{
                ...{
                    position: statePosition,
                    right: 0,
                    left: 0,
                    // zIndex: 2
                },
                ...styleTopBottom
            }}
        >
            <Box
                sx={{
                    position: 'relative'
                }}
            >
                <Box
                    className="loaderLine"
                    sx={(tema) => ({
                        backgroundColor: tema.colorScheme === 'light' ? tema.colors.orange[2] : tema.fn.rgba(tema.colors.orange[5], 0.25)
                    })}
                >
                    <div className="loaderLineChild-1" />
                    <div className="loaderLineChild-2" />
                    <div className="loaderLineChild-3" />
                </Box>

                <Box
                    sx={(tema) => ({
                        position: 'absolute',
                        top: 0,
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[8],
                        paddingLeft: tema.spacing.xs,
                        paddingRight: tema.spacing.xs,
                        borderRadius: tema.radius.sm,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: tema.fontSizes.xs
                    })}
                >
                    Loading..
                </Box>
            </Box>
        </div>
    )
}

export default React.memo(LoaderLine);